<template>
  <div class="header-container">
<b-container class="no-margin">
    <b-row>
<h1 class="p-color"></h1>
    </b-row>
</b-container>
<b-container class="header-padding">
    <h3>Position: <span class="p-color">🤸‍♂ UX Designer</span></h3>
    <h3> Project: <span class="p-color">💻 Website Re-Design</span></h3>
    <h3>Company: <span class="p-color">✊ Non-Profit</span></h3>
    <h3> Timeline: <span class="p-color heading-padding">⏰ November 2017 - June 2018</span></h3>
</b-container>
<b-container>
        <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">

  <iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="700" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FuE9VzWXBWYvOdrTiqJiIOr%2FCluep-Projects%3Fnode-id%3D0%253A1" allowfullscreen></iframe>
  </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
  <iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="700" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FuE9VzWXBWYvOdrTiqJiIOr%2FCluep-Projects%3Fnode-id%3D1%253A2" allowfullscreen></iframe>
   </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
     <iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="700" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FuE9VzWXBWYvOdrTiqJiIOr%2FCluep-Projects%3Fnode-id%3D1%253A5" allowfullscreen></iframe>
     </b-col>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
  <iframe style="border: 1px solid rgba(0, 0, 0, 0.1);" width="700" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FuE9VzWXBWYvOdrTiqJiIOr%2FCluep-Projects%3Fnode-id%3D1%253A5" allowfullscreen></iframe>
    </b-col>
        </b-row>
</b-container>
  <b-container>
    <h4 class="header-padding"><span class="heading5">Other Projects</span></h4>
      <b-row>
            <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/snapsuite">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="SnapSuite Inc - Internship Position" :img-src="snapsuite" img-alt="Image of a macbook pro with the home page of an app I designed for SnapSuite." img-top>
                <p class="card-text">
      Customer portal for companies to create work orders. From concept to final working product.
    </p>
          </b-card>
          </router-link>
    </b-col>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/veganambition">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="The Vegan Ambition - Podcast Host" :img-src="projectImage" img-alt="Image of an iPhone Ten with the homepage of The Vegan Ambition on it." img-top>
                <p class="card-text">
      The Vegan Ambition is a podcast looking to change the discourse about veganism.
                </p>
          </b-card>
          </router-link>
    </b-col>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <router-link to="/glide">
          <b-card class="hvr-grow margin-on-card card-text card-size" title="Glide - Capstone Project" :img-src="glide" img-alt="Image of an iPhone with the logo of Glide on it." img-top>
                <p class="card-text">
      Glide is a task-based daily scheduling application for employees with ASD and their managers.
                </p>
          </b-card>
          </router-link>
    </b-col>
  </b-row>
  </b-container>

  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Righteous");

h1 {
  font-family: "Righteous", cursive;
  font-size: 100px;
          padding-left: 25px;
    padding-right: 10px;
}
h4{
  padding-top:20px;
  padding-bottom:5px;
}
h2{
  font-weight: 800;
}
.font-deco{
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
    background-size: 100% 100%;
}
.header-padding{
  padding-top:40px;
}
.image-padding{
  margin-top:60px;
}
.image-padding2{
  margin-top:30px;
    margin-bottom: 60px;
}
.header-container {
  width: 100%;
}
.no-margin {
  padding-left: 0px;
  padding-right: 0px;
}
.image-paragraph{
  font-size:14px;
  color: #6D6E71;
  margin-top: 5px;

}
.link {
  color: #000000;
  text-decoration: underline;
  font-weight: 600;
  text-decoration-color: #187BC2;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
      transition: background-size .4s ease;
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
}
.link:hover {
  background-size: 100% 100%;
  color: #000000;
}
.heading5 {
      color: #6D6E71;
      font-size: 18px;
      text-transform: uppercase;
      font-weight: 700;
}
.card-text {
  color: black;
}
.margin-on-card {
  margin-bottom: 20px;
}
.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.image-size{
  width:100%;
  padding:0px !important;
  margin: 0px !important;
}
.middle-margin{
  padding-left: 160px;
  padding-right: 160px;
}
@media screen and (max-width: 992px) {
h1{
    font-size: 100px;
            padding-left: 25px;
    padding-right: 10px;
}
h2{
  font-size:26px;
}
h3{
  font-size: 25px;
}
  .middle-margin{
  padding-left: 40px;
  padding-right: 40px;
}
.image-size{
  width:100%;
  margin-bottom: 10px !important;
}
.image-padding2{
  margin-top:0px;
    margin-bottom: 40px;
}
}

/* On screens that are 600px or less, set the background color to olive */
@media screen and (max-width: 600px) {
h1{
    font-size: 65px;
        padding-left: 25px;
    padding-right: 10px;
}
h2{
  font-size:24px;
}
h3{
  font-size: 25px;
}
.header-padding{
  padding-left:10px;
  padding-right:10px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
.image-size{
  width:100%;
  margin-bottom: 10px !important;
}
.image-padding2{
  margin-top:0px;
    margin-bottom: 40px;
}
}

@media screen and (max-width: 400px) {
h1{
    font-size: 63px;
    padding-left: 25px;
    padding-right: 10px;
}
h3{
  font-size:20px;
}
h2{
  font-size:22px;
}
.header-padding{
  padding-left:10px;
  padding-right:10px;
}
.middle-margin{
  padding-left: 10px;
  padding-right: 10px;
}
.image-size{
  width:100%;
  margin-bottom: 10px !important;
}
.image-padding2{
  margin-top:0px;
  margin-bottom: 40px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/cluep.vue